import React from "react";
import ReactDOM from "react-dom";
import { Confirm } from "lib/components/vendor";

export function appendElementToBody(element) {
  const wrapper = document.body.appendChild(document.createElement("div"));
  const component = ReactDOM.render(element, wrapper);
  const cleanup = () => {
    ReactDOM.unmountComponentAtNode(wrapper);
    setTimeout(() => wrapper.remove());
  };
  return cleanup;
}

export function createModal(Modal, { onClose, ...props } = {}) {
  return new Promise((_resolve, _reject) => {
    let _resolved = false;
    let modalRef;
    const resolve = (...args) => {
      _resolve(...args);
      // modalRef.close()
      cleanup();
    };
    const reject = (...args) => {
      _reject(...args);
      // modalRef.close()
      cleanup();
    };
    const handleClose = (...args) => {
      onClose && onClose(...args);
      !_resolved && _resolve();
      cleanup();
    };
    const element = React.createElement(Modal, {
      ...props,
      modalRef: (ref) => (modalRef = ref),
      open: true,
      onClose: handleClose,
      resolve,
      // reject,
    });
    const cleanup = appendElementToBody(element);
  });
}

export default function confirm({
  onCancel,
  onConfirm,
  content = I18n.t("papp.common.are_you_sure"),
  cancelButton = I18n.t("papp.common.cancel"),
  confirmButton,
  ...props
} = {}) {
  return new Promise((resolve, reject) => {
    const handleCancel = (...args) => {
      onCancel && onCancel(...args);
      resolve(false);
      cleanup();
    };
    const handleConfirm = (...args) => {
      onConfirm && onConfirm(...args);
      resolve(true);
      cleanup();
    };
    const element = React.createElement(Confirm, {
      ...props,
      open: true,
      onCancel: handleCancel,
      onConfirm: handleConfirm,
      content,
      cancelButton,
      confirmButton,
    });
    const cleanup = appendElementToBody(element);
  });
}



// WEBPACK FOOTER //
// ./src/lib/utils/modal.js